import configEvents from 'events/configuration';
import evaluateStage from 'actions/configuration/evaluateStage';

export default function fetchConfigSuccess(config) {
  return dispatch => {
    dispatch(configEvents.updateConfig(config));
    dispatch(evaluateStage);
  };
}
